//@flow

import {createSelector} from 'reselect';
import type {StoreShapeType} from 'app/reducers/types';
import type {RoleType} from 'app/roles/types';
import type {BasicUserType} from 'app/user/types';

export const getAllRolesSelector = createSelector<
  StoreShapeType,
  void,
  Array<any>,
  Array<RoleType>
>(
  // $FlowFixMe
  (state) => (state.roles.get('byId').toJS(): any),
  (roles) => Object.values(roles)
);

export const denormalizeRole = (users: any, role: RoleType) => ({
  ...role,
  users: role.users.map<BasicUserType>((id) => users.get(id.toString()).toJS()),
});
